export default __webpack_public_path__ + "static/media/Tamarin Battle Scimitar.50cb9870.jpg";